<template>
  <div class="mailbox-content">
    <template v-if="detail.emailAddress || detail.draftsId || detail.buyerName">
      <template>
        <div class="header" v-if="!detail.draftsId">
          <p style="margin: 0; width: 70%">
            <span class="icon-class">
              <collectionIcon :collection="detail.collection == 0"></collectionIcon>
            </span>
            <span
              @click="handleOutTicketItemCollection"
              class="collection-title"
              style="color: rgba(51, 51, 51, 1)"
            >
              {{ detail.collection == 0 ? '标记重要邮件' : '取消标记重要邮件' }}</span
            >
          </p>
          <div
            class="content-right reply-right"
            style="height: 100%; line-height: 46px; border-left: 1px solid #e4e5e6"
          >
            <span style="color: rgba(102, 102, 102, 1); font-size: 12px; padding: 0 30px"
              >邮件剩余可用量</span
            >
            <span style="color: rgba(51, 51, 51, 1); font-weight: 600; font-size: 12px">{{
              remainingMail
            }}</span>
          </div>
        </div>
        <div class="content" :class="{ 'height-100': detail.draftsId }">
          <div class="content-left reply-left">
            <div class="title">
              <div
                class="cell"
                style="color: #333333; font-weight: bold; font-size: 14px"
                v-if="!detail.draftsId"
              >
                <label style="color: rgba(51, 51, 51, 1); font-size: 12px">{{
                  detail.buyerName
                }}</label>
                <span style="color: #999999; font-size: 12px; font-weight: 400">{{
                  detail.emailAddress
                }}</span>
                <span class="icon-class">
                  <collectionIcon :collection="detail.collection == 0"></collectionIcon>
                </span>
              </div>
              <span style="margin-bottom: 5px" v-else>
                <span style="color: rgba(51, 51, 51, 1)">收件人：</span>
                <span
                  v-if="detail.emailAddressExcelName || detail.buyerName"
                  style="color: rgba(153, 153, 153, 1)"
                  >{{ detail.emailAddressExcelName || detail.buyerName }}</span
                >
                <template v-else>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="detail.emailAddress"
                    placement="top-start"
                  >
                    <span style="color: rgba(153, 153, 153, 1)">{{
                      getTilte(detail.emailAddress)
                    }}</span>
                  </el-tooltip>
                </template>
              </span>
              <div class="cell">
                <label style="color: rgba(102, 102, 102, 1)">邮件主题</label>
                <span style="color: rgba(153, 153, 153, 1)">{{ detail.subject }}</span>
              </div>
            </div>
            <div class="mail">
              <p style="margin: 12px 0; color: #666666">
                {{ detail.draftsId ? detail.updateTime : detail.emailTime }}
              </p>
              <div
                style="
                  background: #f6faff;
                  padding: 8px 12px;
                  white-space: pre-wrap;
                  word-break: break-all;
                  width: 70%;
                  box-sizing: border-box;
                "
                v-html="detail.htmlContent"
              ></div>
              <div class="file-list">
                <span
                  v-for="item in detail.attachments"
                  :key="item.id"
                  class="file-item"
                  @click="downloadFile(item.id)"
                >
                  <i class="el-icon-document"></i>
                  <span class="file-name">{{ item.name }}</span>
                </span>
              </div>
            </div>
            <gj-button
              type="primary"
              :loading="loading"
              class="contet-reply"
              v-if="detail.type === 'To' && detail.status == 'fail'"
              @click="retry"
              >重发</gj-button
            >
            <gj-button
              type="primary"
              class="contet-reply"
              v-if="detail.type === 'From'"
              @click="reply"
              >回复</gj-button
            >
            <gj-button type="primary" class="contet-reply" v-if="detail.draftsId" @click="editDraft"
              >编辑</gj-button
            >
          </div>
        </div>
      </template>
    </template>
    <div v-else style="width: 300px; margin: 50px auto">
      <gj-empty></gj-empty>
    </div>
  </div>
</template>

<script>
import collectionIcon from './components/collection-icon';
import AddMailModal from './modal/add-mail-modal';
import { handleOutTicketItemCollection, outTicketItemResend } from '@/api/crm';
import { downloadAttFile } from '@/api/common';
export default {
  name: 'mailbox-content',
  components: { collectionIcon },
  props: {
    remainingMail: {
      type: Number,
      default: 0,
    },
    detail: {
      type: Object,
      default: () => {
        return {
          collection: 0,
          createUser: '',
          subject: '',
          emailAddress: '',
          htmlContent: '',
          emailId: 0,
          outTicketItemId: '',
          draftsId: '',
        };
      },
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    downloadFile(id) {
      downloadAttFile(id);
    },
    editDraft() {
      const vm = this;
      const modal = this.$gjCreate(AddMailModal, {
        props: {
          draftsId: vm.detail.draftsId,
        },
        on: {
          after() {
            vm.$emit('saveDraftEmail');
            modal.$gjDestroy();
          },
        },
      });
    },
    getTilte(str) {
      let arr = str.split(';');
      return arr.length > 1 ? `${arr[0]}等${arr.length}人` : str;
    },
    // 重发
    retry() {
      this.loading = true;
      outTicketItemResend(this.detail.outTicketItemId)
        .then(() => {
          this.$gjMessage.success('操作成功');
          this.$emit('reSendSuccess');
        })
        .complete(() => {
          this.loading = false;
        });
    },
    // 回复
    reply() {
      const modal = this.$gjCreate(AddMailModal, {
        props: {
          emailAddress: this.detail.emailAddress,
        },
        on: {
          after() {
            modal.$gjDestroy();
          },
        },
      });
    },
    handleOutTicketItemCollection() {
      let parms = {
        outIdList: [this.detail.outTicketItemId],
        type: this.detail.collection == 0 ? 1 : 0,
      };
      handleOutTicketItemCollection(parms).then(() => {
        this.$emit('emailCollection');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.file-list {
  display: flex;
  flex-direction: row;
  background: rgb(246, 250, 255);
  width: 70%;
  flex-wrap: wrap;
  padding-left: 10px;
  color: #1f6eef;
  box-sizing: border-box;
  .file-item {
    margin-right: 10px;
    padding-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    .file-name {
      padding-left: 10px;
    }
  }
}
.icon-class {
  transform: translateY(6px);
  display: inline-block;
}
.collection-title {
  cursor: pointer;
}
.mailbox-content {
  position: relative;
  flex: 1;
  overflow: overlay;
  .header {
    height: 46px;
    line-height: 30px;
    padding: 0 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #e4e5e6;
    display: flex;
    background: #f6f8fb;
    border-radius: 0px 2px 0px 0px;
    flex-direction: row;
    align-items: center;
    padding-left: 16px;
  }
  .height-100 {
    height: 100% !important;
  }
  .content {
    height: calc(100% - 46px);
    display: flex;

    .content-left {
      position: relative;
      border-right: 1px solid #e4e5e6;
      flex: 4;
      padding: 6px 0px 60px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .title {
        .cell {
          height: 25px;
          line-height: 25px;
          color: #666666;

          label {
            margin-right: 16px;
          }
        }

        box-sizing: border-box;
        border-bottom: 1px solid #e4e5e6;
        padding: 0 15px 12px;
      }
      /deep/ .mail {
        position: relative;
        flex: 1;
        overflow: overlay;
        padding: 0 10px;
        * {
          white-space: pre-wrap !important;
          word-break: break-all !important;
        }
      }
      .mail::-webkit-scrollbar {
        display: none;
      }
      .contet-reply {
        position: absolute;
        left: 16px;
        bottom: 12px;
        margin-left: 0 !important;
      }
    }
    .content-right {
      flex: 1;
      padding: 0 15px;
    }
  }
}
</style>
